import React, { useState } from 'react';
import { FaFileAudio } from "react-icons/fa6";
import { errorAlert, successAlert } from '../utils/utils';
import { useStateContext } from '../context/StateContext';
import { goldColour } from '../pages/Home';
import { _UPLOAD } from '../utils/patches';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';

const AddAudioFileToS3 = ({ saveFn, fileId }) => {
    const [loading, setLoading] = useState(false);
    const hiddenFileInput = React.useRef(null);
    const { apiUrl, hideTestButtons } = useStateContext();
    const { user } = useAuthContext(AuthContext);

    

    const handleClick = () => {
        if (loading) return;
        hiddenFileInput.current.click();
    };

    const uploadAudioFile = async (e) => {
        try {
            const file = e.target.files[0];
            if (!file) return;

            setLoading(true);

            // Validate file type
            const validTypes = ['audio/mp3', 'audio/mpeg'];
            if (!validTypes.includes(file.type)) {
                errorAlert("Invalid file format. Please upload an MP3 file.");
                setLoading(false);
                return;
            }

            // Validate file size (max 25MB)
            const maxSize = 25 * 1024 * 1024; // 25MB in bytes
            if (file.size > maxSize) {
                errorAlert("File is too large. Maximum size is 25MB.");
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('fileData', JSON.stringify({
                fileName: fileId,
            }));

            await _UPLOAD({
                route: `${apiUrl}/s3/upload`,
                formData,
                user,
                onSuccess: (data) => {
                    saveFn(data.s3Url);
                    successAlert("File uploaded successfully");
                },
                onError: (error) => {
                    process.env.NODE_ENV === "development" && console.error('Upload error:', error);
                    errorAlert("Error uploading file. Please try again.");
                }
            });
        } catch (error) {
            process.env.NODE_ENV === "development" && console.error("Upload error:", error);
            errorAlert("Error uploading file. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div 
                onClick={handleClick}
                style={{ 
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.6 : 1 
                }}
            >
                <FaFileAudio
                    size={45}
                    color={goldColour}
                />
            </div>
            <input
                type="file"
                accept=".mp3,audio/mp3,audio/mpeg"
                ref={hiddenFileInput}
                style={{ display: "none" }}
                onChange={uploadAudioFile}
                disabled={loading}
            />
        </div>
    );
}

export default AddAudioFileToS3
